import { type FC } from 'react';

import { InputField } from '@wk/components-react16';

import type { OnboardingCheckpointSearchBarProps } from '@/features/onboarding/types/onboarding.types';

const OnboardingCheckpointSearchBar: FC<OnboardingCheckpointSearchBarProps> = ({
  filteredCount,
  inputId = 'checkpoint-search',
  label,
  onSearchChange,
  placeholder,
  resultsLabel,
  searchValue,
  totalCount,
}) => (
  <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
    <div className="w-full sm:max-w-md">
      <InputField
        label={label}
        labelFor={inputId}
        isLabelHidden
        size="small"
      >
        <input
          id={inputId}
          type="search"
          value={searchValue}
          autoComplete="off"
          placeholder={placeholder}
          onChange={onSearchChange}
        />
      </InputField>
    </div>
    <p className="text-xs text-gray-500">
      {filteredCount} of {totalCount} {resultsLabel}
    </p>
  </div>
);

export default OnboardingCheckpointSearchBar;
